module.exports = __webpack_public_path__ + "static/media/emoji.7cf1c759.png";